import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';

import { FatDealCatalogPageOpenOpportunitiesQuery, Security_Status } from '@/__generated__/graphql';
import { MinusScoreIcon } from '@/assets/icons/minusScore';
import Button from '@/components/basicComponents/button';
import { Tooltip } from '@/components/basicComponents/tooltip';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { getUTCDate } from '@/shared/utils/date';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { opportunitiesTableColumns } from '../../constants';
import { TypeWindow } from '../../types';

interface MobileTableProps {
  openOpportunitiesData: FatDealCatalogPageOpenOpportunitiesQuery['OpenOpportunities']['data'];
  openPage: (id: string, type: TypeWindow) => void;
}

const MobileTable = ({ openOpportunitiesData, openPage }: MobileTableProps) => {
  const TableRow = ({ el }: { el: FatDealCatalogPageOpenOpportunitiesQuery['OpenOpportunities']['data'][number] }) => {
    return (
      <MobileTableRowWrap key={el.id}>
        <MobileRow>
          <MobileRowTitle>{opportunitiesTableColumns[0].title}</MobileRowTitle>
          <MobileRowValue isRedirect={el.securityStatus === Security_Status.Open} onClick={() => openPage(el.id, 'opportunityDetails')}>
            {el.name}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{opportunitiesTableColumns[1].title}</MobileRowTitle>
          <MobileRowValue>{el?.subAssetClass ? `${el?.assetClass?.name} - ${el?.subAssetClass?.name}` : el?.assetClass?.name}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{opportunitiesTableColumns[2].title}</MobileRowTitle>
          {el?.subAssetClasses?.length > 1 ? (
            <Tooltip title={el.subAssetClasses.toString().replace(/,/g, ', ')}>
              <MobileRowValue>Multiple ({el.subAssetClasses.length})</MobileRowValue>
            </Tooltip>
          ) : (
            <MobileRowValue>{el?.subAssetClasses && el?.subAssetClasses[0]}</MobileRowValue>
          )}
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{opportunitiesTableColumns[3].title}</MobileRowTitle>
          <MobileRowValue>{el.type}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{opportunitiesTableColumns[4].title}</MobileRowTitle>
          <MobileRowValue>{el.investorDocsDue && getUTCDate(new Date(el.investorDocsDue))}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{opportunitiesTableColumns[5].title}</MobileRowTitle>
          <MobileRowValue>
            {el.aggregateCommitment ? <FormattingTooltip zIndex={1000}>{el.aggregateCommitment}</FormattingTooltip> : <></>}
          </MobileRowValue>
        </MobileRow>
        {el.securityStatus === Security_Status.Open ? (
          <ButtonWrap>
            <Button size="sm" onClick={() => openPage(el.id, 'opportunityDetails')}>
              Allocate
            </Button>
          </ButtonWrap>
        ) : (
          <TooltipWrapper>
            <Tooltip title="Closed">
              <MinusScoreIcon width={29} height={29} fill={themeVar('font.disabled')} />
            </Tooltip>
          </TooltipWrapper>
        )}
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {openOpportunitiesData.length ? (
        openOpportunitiesData.map((el, index) => {
          return <TableRow el={el} key={index} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;

const ButtonWrap = styled.div`
  margin: 0 auto;
`;

const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
